import styles from './ChatMessage.module.scss';
import CopyIcon from 'assets/icons/copy_24.svg?react';
import SendIcon from 'assets/icons/send_24.svg?react';
import DeleteIcon from 'assets/icons/delete_24.svg?react';
import ErrorIcon from 'assets/icons/error_16.svg?react';
import {
  TextButton,
  TextButtonColor,
  TextButtonOrder,
} from 'components/uikit/buttons/TextButton.tsx';
import { useMemo, useRef, useState } from 'react';
import { AppMenu, AppMenuItem } from 'components/uikit/menu/AppMenu.tsx';
import { showSuccessToast } from 'components/uikit/toast/showToast.tsx';
import { useScopedTranslation } from 'application/localization/useScopedTranslation.ts';
import { MessageModel } from './types/chatMessage.ts';

type ChatMessageProps = {
  message: MessageModel;
  onSendAgain: () => void;
  onDelete: () => void;
  isError?: boolean;
};

export const ChatMessage = (props: ChatMessageProps) => {
  const { message, isError } = props;

  const i18n = useScopedTranslation('Component.ChatBot');

  const menuAnchorRef = useRef<HTMLDivElement>(null);
  const [showErrorMenu, setShowErrorMenu] = useState(false);
  const menuItems: AppMenuItem[] = useMemo(
    () => [
      {
        id: 'send-again',
        key: 'send-again',
        text: i18n.t('error_menu.send'),
        icon: <SendIcon />,
        className: styles.menuItem,
        onClick: () => props.onSendAgain(),
      },
      {
        id: 'delete',
        key: 'delete',
        text: i18n.t('error_menu.delete'),
        icon: <DeleteIcon />,
        className: styles.menuItem,
        onClick: () => props.onDelete(),
      },
    ],
    [],
  );

  const onTextCopy = async () => {
    await navigator.clipboard.writeText(message.text);
    showSuccessToast({
      content: {
        title: i18n.t('copy_toast.title'),
        description: i18n.t('copy_toast.description'),
      },
      options: { autoClose: 1500 },
    });
  };

  return (
    <>
      <div
        className={
          message.isLlmResponse ? styles.llmResponse : styles.userMessage
        }
      >
        {message.text}
        {message.isLlmResponse && (
          <TextButton
            title={i18n.t('copy')}
            icon={<CopyIcon />}
            color={TextButtonColor.Primary}
            className={styles.copyButton}
            onClick={onTextCopy}
          />
        )}
      </div>
      {isError && (
        <div className={!message.isLlmResponse && styles.alignRight}>
          <div
            ref={menuAnchorRef}
            onClick={() => setShowErrorMenu((prev) => !prev)}
          >
            <TextButton
              icon={<ErrorIcon />}
              title={i18n.t('error')}
              color={TextButtonColor.Destroy}
              className={styles.errorButton}
              order={TextButtonOrder.TitleIcon}
            />
          </div>
          <AppMenu
            menuItems={menuItems}
            open={showErrorMenu}
            anchorEl={menuAnchorRef.current}
            onClose={() => setShowErrorMenu(false)}
            onClick={() => setShowErrorMenu(false)}
          />
        </div>
      )}
    </>
  );
};
